import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

const AboutTradies = () => {
  return (
    <div className="container mx-auto px-4 py-12" data-testid="about-page">
      <div className="max-w-4xl mx-auto space-y-12">
        <div className="text-center space-y-4">
          <h1 className="text-4xl font-bold">About & Safety GoTradies</h1>
          <p className="text-lg text-muted-foreground">
            Your trusted platform for connecting with verified Australian tradies
          </p>
        </div>

        <Card>
          <CardContent className="p-8 space-y-6">
            <div>
              <h2 className="text-2xl font-bold mb-4">What is GoFella?</h2>
              <p className="text-muted-foreground leading-relaxed">
                GoFella is Australia's trusted marketplace connecting customers with verified tradies.
                We provide a safe, transparent platform where you can find qualified professionals,
                get quotes, and complete your projects with confidence.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4">Safety & Verification</h2>
              <div className="space-y-4">
                <div className="flex gap-4">
                  <div className="text-3xl">✅</div>
                  <div>
                    <h3 className="font-semibold mb-1">ABN Verification</h3>
                    <p className="text-sm text-muted-foreground">
                      All tradies must provide a valid Australian Business Number
                    </p>
                  </div>
                </div>
                
                <div className="flex gap-4">
                  <div className="text-3xl">📝</div>
                  <div>
                    <h3 className="font-semibold mb-1">Licence Checks</h3>
                    <p className="text-sm text-muted-foreground">
                      We verify required licences for regulated trades
                    </p>
                  </div>
                </div>
                
                <div className="flex gap-4">
                  <div className="text-3xl">🛡️</div>
                  <div>
                    <h3 className="font-semibold mb-1">Insurance Verification</h3>
                    <p className="text-sm text-muted-foreground">
                      Tradies provide proof of public liability insurance
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4">Stay Safe</h2>
              <ul className="space-y-2 text-muted-foreground list-disc list-inside">
                <li>Always communicate through the GoFella platform</li>
                <li>Check verification badges before engaging</li>
                <li>Get everything in writing via our quote system</li>
                <li>Report any suspicious activity immediately</li>
                <li>Never pay full amount upfront</li>
              </ul>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AboutTradies;
